import { Eyebrow, TitleBar } from './atoms'
import { useLang, t } from '../lib/lang'
import type { RepertorioEntry } from '../lib/types'

export function Repertorio({ items }: { items: RepertorioEntry[] }) {
  const { lang } = useLang()
  if (!items.length) return null
  return (
    <section className="ax-pad-section" style={{ background: 'var(--paper)', padding: '120px 48px' }}>
      <div className="ax-grid-repertorio" style={{
        maxWidth: 1280, margin: '0 auto',
        display: 'grid', gridTemplateColumns: '1fr 1.4fr',
        gap: 80, alignItems: 'flex-start',
      }}>
        <div>
          <Eyebrow>{t(lang, 'section_repertorio_eyebrow')}</Eyebrow>
          <TitleBar size={44}>
            {t(lang, 'section_repertorio_title_a')}<br />{t(lang, 'section_repertorio_title_b')}
          </TitleBar>
          <p style={{
            fontFamily: 'var(--font-body)', fontSize: 15, lineHeight: 1.6,
            color: 'var(--fg-muted)', marginTop: 24, maxWidth: 360,
          }}>{t(lang, 'section_repertorio_intro')}</p>
        </div>

        <ul className="ax-list-repertorio" style={{
          listStyle: 'none', padding: 0, margin: 0,
          display: 'grid', gridTemplateColumns: '1fr 1fr',
          borderTop: '1px solid var(--line)',
        }}>
          {items.map((a, i) => (
            <li key={a.id} style={{
              fontFamily: 'var(--font-display)', fontWeight: 500,
              textTransform: 'uppercase', letterSpacing: '0.04em',
              fontSize: 26, padding: '22px 0',
              borderBottom: '1px solid var(--line)',
              borderRight: i % 2 === 0 ? '1px solid var(--line)' : 'none',
              paddingLeft: i % 2 === 1 ? 28 : 0,
              color: 'var(--fg)',
            }}>{a.artist}</li>
          ))}
        </ul>
      </div>
    </section>
  )
}
